<script>
  import { derived } from "svelte/store";
  import { format } from "date-fns"
  import Stack from "../../../components/layout/Stack.svelte";

  /**
   * svelte store readable
   */
  export let executions

  export let direction = "past"

  const executionsByDates = derived(executions, executions => {
    if (executions.length === 0) return new Map()
    const executionsByDates = new Map()
    for (const execution of executions) {
      const dateString = format(new Date(execution.scheduledAt), "yyyy/MM/dd")
      if (executionsByDates.has(dateString)) {
        executionsByDates.get(dateString).push(execution)
      } else {
        executionsByDates.set(dateString, [execution])
      }
    }
    return executionsByDates
  })
  const sortedDates = derived(executionsByDates, executionsByDates => {
    const dates = Array.from(executionsByDates.keys())
    if (direction === "past") return dates.toSorted().toReversed()
    return dates.toSorted()
  })
</script>

<Stack direction="vertical" gap="1rem">
  {#each $sortedDates as date}
    <Stack direction="vertical" gap=".5rem">
      <div style="width: 100%; padding: .3rem .5rem; background-color: lightgrey">{date}</div>
      {#each $executionsByDates.get(date) as execution}
        <Stack direction="horizontal" gap="1rem" style="padding-left: 1rem">
          <div>{format(new Date(execution.scheduledAt), "HH:mm")}</div>
          <div style="width: 100px;">
            {#if execution.status === "scheduled"}
              <span style="color: #003f81">実行予定</span>
            {:else if execution.status === "executed"}
              <span style="color: green">実行成功</span>
            {:else if execution.status === "executing"}
              <span style="color: green">実行中</span>
            {:else if execution.status === "failed"}
              <span style="color: #c84c4c">実行失敗</span>
            {:else if execution.status === "cancelled"}
              <span style="color: darkgrey">キャンセル</span>
            {:else if execution.status === "timeout"}
              <span style="color: #c84c4c">タイムアウト</span>
            {/if}
          </div>
          <div>計画パラメタ: {execution.schedulingParameter}</div>
          <div style="align-self: end; color: darkgrey; font-size: .8rem">(executionId: {execution.id},
            scheduleId: {execution.scheduleId})
          </div>
        </Stack>
      {/each}
    </Stack>
  {:else}
    <span>実行がありません。</span>
  {/each}
</Stack>